import React, {FunctionComponent} from "react";
import FlexContent, {FlexContentAlignment, FlexContentDirection, FlexContentJustify, FlexContentSpacing} from "../snippet/flex-content/FlexContent";
import Paragraph, {ParagraphAlignment} from "../snippet/Paragraph";

type EmptyContentMessageProps = {
    svg: React.FunctionComponent;
    message: string;
    children?: React.ReactNode;
};

const EmptyContentMessage: FunctionComponent<EmptyContentMessageProps> = ({
    svg,
    message,
    children
}) => {
    return (
        <FlexContent
            cssClass="content-message"
            direction={FlexContentDirection.COLUMN}
            alignment={FlexContentAlignment.CENTER}
            spacing={FlexContentSpacing.MEDIUM}
            justify={FlexContentJustify.CENTER}
        >
            {React.createElement(svg)}
            <Paragraph alignment={ParagraphAlignment.CENTER}><span dangerouslySetInnerHTML={{__html: message}}/></Paragraph>
            {children}
        </FlexContent>
    );
};

export default EmptyContentMessage;
